import Vue from 'vue'

Vue.filter('numFormat', numFormat)
function numFormat(value) {
  if (!value) return '0'
  const intPart = Number(value).toFixed(0) // 获取整数部分
  return intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
}



// WEBPACK FOOTER //
// ./src/filter/index.js